import { Route } from 'react-router';
import { MyVaultPage } from '../MyVaultPage';
import { getMyVaultPath } from '../path/path';
import { MyVaultAccountDetailsPage } from '../_MyVaultAccountDetailsPage/MyVaultAccountDetailsPage';
import { getVaultAccountDetailsPath } from '../_MyVaultAccountDetailsPage/path/path';

export const MyVaultRoutes = [
  <Route key={getMyVaultPath()} path={getMyVaultPath()} element={<MyVaultPage />} />,
  <Route
    key={getVaultAccountDetailsPath()}
    path={getVaultAccountDetailsPath()}
    element={<MyVaultAccountDetailsPage />}
  />,
];
